import { render, staticRenderFns } from "./PurchaseOrderForm.vue?vue&type=template&id=6efbb4e7&scoped=true&"
import script from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderForm.vue?vue&type=style&index=0&id=6efbb4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efbb4e7",
  null
  
)

component.options.__file = "PurchaseOrderForm.vue"
export default component.exports